import { Button } from 'reactstrap';
import React, { useState } from 'react';
import { formatDateForAudioDownloads } from '../../../../../../utils/fuctions/formattedDateForAudioDownloads';
import { toast } from 'react-toastify';
import fileSaver from 'file-saver';
import ReportService from '../../service';
import ReactLoader from 'components/Loader';
import { formatTimeForAudioDownloads } from 'utils/fuctions/formattedTimeForAudioDowloads';

export const DownloadButton = ({ row, isCallMade = false }) => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadMultipleAudios = (audioList) => {
    setIsLoading(true);

    const downloadPromises = audioList.map(
      ({ uniqueid, nameAgent, date, telephone }) => {
        const formattedDate = formatDateForAudioDownloads(date);
        const formattedTime = formatTimeForAudioDownloads(date);

        const audioDataDTO = {
          uniqueid,
          nameAgent,
          formattedDate,
          formattedTime,
          telephone
        };

        return ReportService.downloadAudio(uniqueid)
          .then((res) => {
            if (res.data.size !== 0) {
              fileSaver.saveAs(
                new Blob([res.data], { type: res.headers['content-type'] }),
                `${audioDataDTO.formattedDate}-${audioDataDTO.formattedTime}-${
                  audioDataDTO.telephone ?? ''
                }-${audioDataDTO.nameAgent ?? ''}.gsm`
              );
            }
          })
          .catch((err) => {
            console.log(err);
            toast.error('Erro ao fazer download de arquivo');
          });
      }
    );

    Promise.all(downloadPromises).finally(() => setIsLoading(false));
  };

  return (
    <div style={{ position: 'relative', width: 'min-content' }}>
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            left: '6px',
            top: '3px',
            zIndex: '10'
          }}
        >
          <ReactLoader width={20} height={20}></ReactLoader>
        </div>
      )}
      <Button
        disabled={!(row.disposition === 'ANSWERED') || isLoading}
        onClick={() =>
          downloadMultipleAudios([
            {
              uniqueid: row.uniqueid,
              nameAgent: row.nameAgent,
              date: row.calldateStart ?? row.callDateStart,
              telephone: isCallMade ? row.dst : row.clidNum
            }
          ])
        }
        color="success"
        size="sm"
      >
        <i className="fas fa-cloud-download-alt"></i>
      </Button>
    </div>
  );
};
